import FirebaseController from "../controllers/FirebaseController";

/**
 * Abstraction from Firebase, repositories should access this dude
 */

export default {

	getAlbum(albumId) {
		return FirebaseController.db().collection('albums').doc(albumId)
	},
	
	getUserAlbums(callback) {
		let userId = FirebaseController.userId()
		return FirebaseController.db().collection('albums').where("owner_id", "==", userId)
			.onSnapshot(result => {
				callback(result.docs);
			});
	},

	createNewAlbum(albumTitle) {
		return FirebaseController.db().collection('albums').add(
			{
				title: albumTitle,
				password: this.randomString(20, "A"),
				is_active: true,
				is_email_required: true,
				is_comments_allowed: false,
				event_date: '',
				expiration_date: '',
				cover: '',
				photos: [],
				owner_id: FirebaseController.userId(),
				owner_name: FirebaseController.user().displayName,
				owner_photo_url: FirebaseController.userProfilePicture()
			}
		)
	},

	/**
	 * Generated a randomString  
	 */
	randomString(len, an){
		an = an&&an.toLowerCase();
		var str="", i=0, min=an=="a"?10:0, max=an=="n"?10:62;
		for(;i++<len;){
		  var r = Math.random()*(max-min)+min <<0;
		  str += String.fromCharCode(r+=r>9?r<36?55:61:48);
		}
		return str;
	},

	deleteAlbum(id) {
		return FirebaseController.db().collection('albums').doc(id).delete()
	},

	uploadPhoto(albumId, photoFile, metadata, progressCallback, statusCallback, completeCallback, errorCallback) {
		// let metadata = { contentType: 'image/jpeg', };
		// Upload the file and metadata
		let uploadTask = FirebaseController.storage().ref()
			.child(`${FirebaseController.userId()}/albums/${albumId}/${photoFile.name}`)
			.put(photoFile, metadata);

		// Register three observers:
		// 1. 'state_changed' observer, called any time the state changes
		// 2. Error observer, called on failure
		// 3. Completion observer, called on successful completion
		uploadTask.on('state_changed', snapshot => {
			// Observe state change events such as progress, pause, and resume
			// Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
			var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
			progressCallback(progress)
			statusCallback(snapshot.state)
		}, error => {
			// Handle unsuccessful uploads
			console.log('DatabaseManager error ', error)
			errorCallback(error)
		}, () => {
			// Handle successful uploads on complete
			// For instance, get the download URL: https://firebasestorage.googleapis.com/...
			uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
				completeCallback(downloadURL)
			}).catch(error => {
				errorCallback(error)
			});
		});
	},

	newBetaSignup(email) {
		return FirebaseController.db().collection('newsletters').add(
			{
				email: email,
				date: new Date(),
				type: 'beta'
			}
		)
	},
}



// WEBPACK FOOTER //
// ./src/data/DatabaseManager.js